export function getItemFromLocalStorage(itemName: string) {
  return localStorage.getItem(itemName) || "";
}
